<script lang="ts">
    import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/entities/entities";

    //Props
    export let rewardsBranding: RewardsStorefrontValuesBrandingEntity;

    //Variables
    const {
        general: { theme },
        popUpWidget: { launcher, popUpContent },
    } = rewardsBranding;
</script>

<div
    style:--gw-rd-popup-widget-banner__font-color={popUpContent.banner
        .fontColor}
    style:--gw-rd-popup-widget-launcher__theme-color={theme[
        launcher.appearance.themeColor
    ]}
    style:--gw-rd-popup-widget-launcher__font-color={launcher.appearance
        .fontColor}
    style:--gw-rd-popup-widget-launcher__icon-color={launcher.icon.color}
    style:--gw-rd-popup-widget-launcher__desktop_side-spacing={`${launcher.position.desktop.side}px`}
    style:--gw-rd-popup-widget-launcher__desktop_bottom-spacing={`${launcher.position.desktop.bottom}px`}
    style:--gw-rd-popup-widget-launcher__mobile_side-spacing={`${launcher.position.mobile.side}px`}
    style:--gw-rd-popup-widget-launcher__mobile_bottom-spacing={`${launcher.position.mobile.bottom}px`}
>
    <slot />
</div>
